import { render, staticRenderFns } from "./IpsPagination.vue?vue&type=template&id=4f703808"
import script from "./IpsPagination.vue?vue&type=script&lang=js"
export * from "./IpsPagination.vue?vue&type=script&lang=js"
import style0 from "./IpsPagination.vue?vue&type=style&index=0&id=4f703808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports